import { Container, Rectangle, Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';
// import { isDesktop } from "react-device-detect";

const asyncWait = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

class AnimatedIcon extends Container {
	item = null;
	bg = null;
	fg = null;
	fg2 = null;
	ring = null;
	fgmask = null;
	frameTween = null;
	reel_position = null;
	constructor(item, isBlur, first, isBait, pos) {
		super();
		this.reel_position = pos;
		this.item = item;
		this.sprites = [];
		window.addEventListener(
			EVENTS.SETTINGS_UPDATE,
			this.settingsChanged.bind(this),
			false
		);
		if (isBlur || isBait) {
			if (item.iconBg) {
				this.bg = Sprite.from(Texture.from(item.iconBg));
				this.bg.x = -(this.bg.width / 2 - this.item.width / 2);
				this.bg.y = -(this.bg.height / 2 - this.item.height / 2);
			} else {
				this.bg = new Sprite();
			}

			this.bg.alpha = 0.4;
			this.addChild(this.bg);
			this.fg = Sprite.from(Texture.from(item.iconBlurred));

			this.addChild(this.fg);
		} else {
			if (this.item.animation.bg !== undefined) {
				this.bg = HELPERS.getAnimatedSprite(this.item.animation.bg);
				if (!this.item.isSticked) {
				}
				this.addChild(this.bg);
				this.sprites.push(this.bg);
				if (this.item.animation.bg.offsetX) {
					this.bg.x = this.item.animation.bg.offsetX;
				}
				if (this.item.animation.bg.offsetY) {
					this.bg.y = this.item.animation.bg.offsetY;
				}
				if (this.item.animation.bg.scale) {
					this.bg.scale.set(
						this.item.animation.bg.scale.x,
						this.item.animation.bg.scale.y
					);
				}
				if (this.item.isSticked) {
					if (GameConfigs.settings.game_animation) {
						this.bg.gotoAndPlay(0);
					} else {
						this.bg.gotoAndStop(0);
					}
				} /**/
			} else {
				if (item.iconBg) {
					this.bg = Sprite.from(Texture.from(item.iconBg));
					this.bg.anchor.set(0.5, 0.5);
					this.bg.x = this.item.width / 2 + 3;
					this.bg.y = this.item.height / 2 + 3;
					this.bg.alpha = first ? 1 : 0;
					this.bg.scale.set(0.96);
				} else {
					this.bg = new Sprite();
				}
				this.addChild(this.bg);
				if (item.iconBorder) {
					this.iconBorder = Sprite.from(Texture.from(item.iconBorder));
					this.iconBorder.anchor.set(0.5, 0.5);
					this.iconBorder.x = this.item.width / 2 + 3;
					this.iconBorder.y = this.item.height / 2 + 3;
					// this.iconBorder.zIndex = 100000;
				}
				// this.bg.scale.set(0.95);
			}

			if (this.item.animation.frame) {
				this.frame = HELPERS.getAnimatedSprite(this.item.animation.frame);
				if (!this.item.isSticked) {
				}
				this.addChild(this.frame);
				this.sprites.push(this.frame);
				this.frame.alpha = 0;
				this.frame.position.x = isDesktop ? 8 : 4;
				this.frame.position.y = isDesktop ? 7 : 3;
				if (this.item.animation.frame.scale !== undefined) {
					this.frame.scale.set(
						this.item.animation.frame.scale.x,
						this.item.animation.frame.scale.y
					);
				}

				if (this.item.animation.frame.offsetX) {
					this.frame.position.x = this.item.animation.frame.offsetX;
				}
				if (this.item.animation.frame.offsetY) {
					this.frame.position.y = this.item.animation.frame.offsetY;
				}
			}

			if (this.item.animation.fog) {
				this.fog = HELPERS.getAnimatedSprite(this.item.animation.fog);
				this.addChild(this.fog);
				// this.sprites.push(this.fog);
				this.fog.anchor.set(0.5, 0.5);
				this.fog.x = this.item.width / 2;
				this.fog.y = this.item.height / 2 - 10;
				// this.fog.scale.set(0.95);
				this.fog.gotoAndPlay(0);
			}
			if (this.item.animation.fg !== undefined) {
				this.fg = HELPERS.getAnimatedSprite(this.item.animation.fg);
				this.addChild(this.fg);
				this.sprites.push(this.fg);

				// this.fg.scale.set(1.05, 1.05);
				if (this.item.animation.fg.scale) {
					this.fg.scale.set(
						(this.item.animation.fg.scale.x, this.item.animation.fg.scale.y)
					);
				}
				if (item.fgmask) {
					this.fgmask = Sprite.from(Texture.from(item.fgmask));
					this.fg.addChild(this.fgmask);
					this.fg.mask = this.fgmask;
				}
				this.fg.anchor.set(0.5);
				this.fg.position.x = isDesktop
					? this.item.width / 2 + 4
					: this.item.width / 2 + 2;
				this.fg.position.y = isDesktop
					? this.item.height / 2
					: this.item.height / 2;
				if (this.item.animation.fg.offsetX !== undefined) {
					this.fg.x = this.item.width / 2 + this.item.animation.fg.offsetX;
				}
				if (this.item.animation.fg.offsetY !== undefined) {
					this.fg.y = this.item.height / 2 + this.item.animation.fg.offsetY;
				}
			}

			if (this.item.animation.fg2Index >= 0) {
				let data = this.item.animation.fg2Data[this.item.animation.fg2Index];
				if (data.pattern !== undefined) {
					this.fg2 = HELPERS.getAnimatedSprite(data);
					this.addChild(this.fg2);
					this.sprites.push(this.fg2);

					if (data.scale !== undefined) {
						this.fg2.scale.set(data.scale.x, data.scale.y);
					}
					if (data.offsetX !== undefined) {
						this.fg2.x = data.offsetX;
					}
					if (data.offsetY !== undefined) {
						this.fg2.y = data.offsetY;
					}
				} else {
					this.fg2 = new this.item.Fg2Class(data);
					if (data.offsetX !== undefined) {
						this.fg2.x = data.offsetX;
					}
					if (data.offsetY !== undefined) {
						this.fg2.y = data.offsetY;
					}
					if (data.scale !== undefined) {
						this.fg2.scale.x = data.scale.x;
						this.fg2.scale.y = data.scale.y;
					}
					this.addChild(this.fg2);
				}
			}

			if (item.iconBorder) {
				this.addChild(this.iconBorder);
			}
			if (this.item.id === 12) {
				this.fg.gotoAndPlay(0);
			}
			this.interactive = true;
			this.cursor = 'pointer';
			this.on(
				window.isMobile || window.isTablet ? 'tap' : 'click',
				this.clickHandler.bind(this)
			);
			// this.graphics = new Graphics();
			// this.graphics.clear();
			// this.graphics.beginFill(0xe5a7dd);
			// this.graphics.drawRoundedRect(0, 0, 226, 228, 0);
			// this.graphics.alpha = 0.4
			// this.addChild(this.graphics)
			if (window.isMobile) {
				this.hitArea = new Rectangle(5, 5, 113 - 10, 114 - 10);
			} else {
				this.hitArea = new Rectangle(0, 0, 226, 228);
			}
		}
	}

	clickHandler(evt) {
		HELPERS.dispatchCustomEvent(EVENTS.ICON_CLICKED, {
			id: this.item.id,
			reel_position: this.reel_position,
			icon: this
		});
	}

	settingsChanged(e) {
		for (var i = 0; i < this.sprites.length; i++) {
			if (e.detail.game_animation === undefined) return;
			if (!e.detail.data.game_animation) {
				this.sprites[i].gotoAndStop(0);
			}
		}
	}
	disable() {
		if (this.frameTween) {
			this.frameTween.stop();
		}
		if (this.animateMinor) {
			this.animateMinor.stop();
			this.animateMinor = null;
			this.fg.scale.set(this.item.animation.fg.scale.x);
		}
		if (!this.item.isSticked) {
			if (this.frame) {
				this.frameTween = new Tween(this.frame)
					.to({ alpha: 0 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}
		if (!this.item.isSticked) {
			this.alpha = 0.3;
		}
	}

	animateLoop() {
		this.animate();
	}

	stopLoop() {
		this.disable();
		this.alpha = 1;
	}

	enable() {
		this.alpha = 1;
	}

	showBG(delay, time, alp) {
		new Tween(this.bg)
			.to({ alpha: alp }, time)
			.delay(delay)
			.easing(Easing.Linear.None)
			.start();

		if (this.iconBorder) {
			new Tween(this.iconBorder)
				.to({ alpha: alp }, time)
				.delay(delay)
				.easing(Easing.Linear.None)
				.start();
		}
	}
	animateFrame(frame) {
		this.frame.gotoAndPlay(frame);
		this.frameTween = new Tween(this.frame)
			.to({ alpha: 1 }, 250)
			.easing(Easing.Linear.None)
			.start();
	}
	//TODO animate only winner icons
	async animate() {
		if (GameConfigs.settings.game_animation) {
			await asyncWait(200);

			if (this.frameTween) {
				this.frameTween.stop();
			}

			if (this.item.animation.bg !== undefined) {
				this.bg.gotoAndPlay(0);
			}
			if (this.item.animation.fg !== undefined) {
				this.fg.gotoAndPlay(0);

				if (this.item.type === 'minor') {
					this.animateMinor = new Tween(this.fg.scale)
						.to(
							{
								x: this.item.animation.fg.scale.x + 0.05,
								y: this.item.animation.fg.scale.y + 0.08
							},
							500
						)
						.yoyo(true)
						.repeat(Infinity)
						.easing(Easing.Linear.None)
						.start();
				}
				if (this.item.id === 12) {
					this.crystalTween = new Tween(this.item.animation.fg.scale)
						.to(
							{
								x: this.item.fg.animation.scale.x + 0.02,
								y: this.item.animation.fg.scale.y + 0.02
							},
							200
						)
						.yoyo(true)
						.repeat(3)
						.easing(Easing.Linear.None)
						.onComplete(() => {
							this.crystalTween.stop();
							this.crystalTween = null;
						})
						.start();
				}
			}
			if (this.item.animation.fg2Index >= 0) {
				if (this.fg2.gotoAndPlay) {
					this.fg2.gotoAndPlay(0);
				} else if (this.fg2.animate) {
					this.fg2.animate();
				}
			}
			if (this.item.animation.frame !== undefined) {
				if (!this.item.isSticked) {
					this.frame.gotoAndPlay(0);
					this.frameTween = new Tween(this.frame)
						.to({ alpha: 1 }, 250)
						.easing(Easing.Linear.None)
						.start();
				}
			}
		} else {
			if (this.item.animation.frame !== undefined) {
				if (this.frame) {
					this.frame.gotoAndStop(0);
					this.frameTween = new Tween(this.frame)
						.to({ alpha: 1 }, 250)
						.easing(Easing.Linear.None)
						.start();
					if (!this.item.isSticked) {
						this.frame.gotoAndStop(0);
					}
				}
			}
		}
	}
}

export default AnimatedIcon;
